import { render, staticRenderFns } from "./ConversationTabInfoV2.vue?vue&type=template&id=6acf2c09&scoped=true"
import script from "./ConversationTabInfoV2.vue?vue&type=script&lang=js"
export * from "./ConversationTabInfoV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationTabInfoV2.vue?vue&type=style&index=0&id=6acf2c09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf2c09",
  null
  
)

export default component.exports